import { render, staticRenderFns } from "./ConformationModal.vue?vue&type=template&id=6d770d75&"
import script from "./ConformationModal.vue?vue&type=script&lang=js&"
export * from "./ConformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports